var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('Header'),(_vm.alert.message)?_c('div',{class:("alert " + (_vm.alert.type))},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }